import type { Language } from "@helpers/I18nHelper";
import Blog from "@modules/blogs/pages/Blog";
import BlogList from "@modules/blogs/pages/BlogList";
import HomePage from "@modules/home/pages/HomePage";
import DiscordAuthCallback from "@modules/login/DiscordAuthCallback";
import GoogleAuthCallback from "@modules/login/GoogleAuthCallback";
import Basket from "@modules/order/Basket";
import { OrderTracking } from "@modules/order/pages/OrderTracking";
import CGV from "@modules/policies/pages/CGV";
import PC from "@modules/policies/pages/PC";
import Reviews from "@modules/review/pages/Reviews";
import ValorantPage from "@modules/valorant/pages/ValorantPage";
import i18next from "i18next";
import { Navigate, type RouteObject } from "react-router";
import getFAQRoutes from "./subRoutes/FAQRoutes";
import getLoLRoutes from "./subRoutes/LoLRoutes";

const getPublicRoutes = (lang: Language): RouteObject[] => {
  const t = (key: string) => i18next.t(`routes.public.${key}`, { lng: lang });

  return [
    {
      element: <HomePage />,
      path: t("home"),
      handle: { routeId: "home" },
    },

    {
      element: <BlogList />,
      path: t("blogs"),
      handle: { routeId: "blogs" },
    },
    {
      element: <Blog />,
      path: `${t("blogs")}/:slug`,
      handle: { routeId: "blog_post" },
    },

    ...getLoLRoutes(lang),

    ...getFAQRoutes(lang),

    {
      element: <ValorantPage />,
      path: t("valorant"),
      handle: { routeId: "valorant" },
    },
    {
      element: <ValorantPage />,
      path: `${t("valorant")}/:region`,
      handle: { routeId: "valorant_region" },
    },

    {
      element: <Basket />,
      path: t("basket"),
      handle: { routeId: "basket" },
    },

    {
      element: <GoogleAuthCallback />,
      path: "/auth/google/callback", // Absolute callbacks usually don't translates
    },
    {
      element: <DiscordAuthCallback />,
      path: "/auth/discord/callback",
    },

    {
      element: <Navigate to={t("home")} />,
      path: t("order"),
      handle: { routeId: "order" },
    },
    {
      element: <OrderTracking />,
      path: `${t("order")}/:token`,
      handle: { routeId: "order_token" },
    },

    {
      element: <CGV />,
      path: t("cgv"),
      handle: { routeId: "cgv" },
    },
    {
      element: <PC />,
      path: t("pc"),
      handle: { routeId: "pc" },
    },
    {
      element: <Reviews />,
      path: t("reviews"),
      handle: { routeId: "reviews" },
    },
  ];
};

export default getPublicRoutes;
